import styled from 'styled-components';

const InputWithLabelWrapper = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: 8px;
  }
`;

export default InputWithLabelWrapper;
